declare global {
  interface Window {
    ANALYTICS_DEBUG: boolean;
  }
}

// @ts-ignore
import instrumentMethods from 'instrument-methods';

export const analyticsLogger = (methodName: string, args: any[]) => {
  if (window?.ANALYTICS_DEBUG) {
    // eslint-disable-next-line no-console
    console.log(`analytics.${methodName}()`, ...args);
  }
};

export const instrumentAnalytics = (analytics: any) =>
  instrumentMethods(analytics, { after: analyticsLogger });
